import { Inject, inject, Injectable } from '@angular/core';
import { VlDataService } from '../vl-data/vl-data.service';
import { VlHttpService } from '../vl-http/vl-http.service';
import { HTTPAPIConfig } from '../vl-http/http-api.config';
import { APIConfigMapping } from '../vl-http/api-mapping-config.cnst';
import { DomSanitizer } from '@angular/platform-browser';
import { ENV_CONFIG } from '../../tokens/env.token';


@Injectable({
  providedIn: 'root'
})
export class StreamBlobService {



  constructor(private dataService:VlDataService, private httpService:VlHttpService,private sanitizer:DomSanitizer,@Inject(ENV_CONFIG) private APP_SETTINGS: any) { }

   streamProjectImage(blob_name:any){
      const apiConfig: HTTPAPIConfig = this.dataService.deepClone(APIConfigMapping['STREAM_API']);
      apiConfig.postData = {
        blob_url: blob_name
      }
      return this.httpService.placeAPICall(apiConfig);
    }

  async fetchImage(blobUrl: string): Promise<any> {
    const apiUrl = `${this.APP_SETTINGS.URL_MAPPING.PROJ_API}stream-file`;

    try {
        const response = await fetch(apiUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'ngrok-skip-browser-warning': 'true',
            },
            body: JSON.stringify({ blob_url: blobUrl })
        });

        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        const blob = await response.blob();
        const objectUrl = URL.createObjectURL(blob);

        return objectUrl;
    } catch (err) {
        console.error('Image fetch failed:', err);
        return null;
    }
}

}
